import api from './apiClient'


export default {
  // 🔎 SEARCH
  async search(params) {
    const res = await api.get('catalog', { params })
    return res.data
  },
  async getProductDetails(asin) {
    const res = await api.get(`/catalog/product-detail?asin=${asin}`)
    return res.data
  },
  async globalSearch(data) {
    const res = await api.post('/search', data)
    return res.data
  },
  async searchBot(data) {
    const res = await api.post('/catalog/search-bot', data)
    return res.data
  },

}